import { Suspense, lazy } from "react";
import { GuestGuard } from "./guards/GuestGuard";
import { LoadingScreen } from "./components/loading-screen";
import AuthGuard from "./guards/AuthGuard";
import { DashboardLayout } from "./containers/dashboard-layout";
import { Navigate } from "react-router-dom";
import ForgotPassword from "./components/login/forgot-password";
import ErrorBoundary from "./components/ErrorBoundary";

// Auth components
// Removed direct import of AuthCallbackHandler


const Loadable = (Component) => (props) =>
(
  <ErrorBoundary>
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  </ErrorBoundary>
);


// Dashboard Menu's
const Employees = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/employees")));
const BusinessHeads = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/businessheads")));
const Subscriptions = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/subscription")));
const TaxAccounts = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/taxaccounts")));
const Paymentprofiles = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/paymentProfiles")));
const PaymentProfileDetailPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/paymentProfiles/detail")));
const PaymentChannels = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/paymentChannels")));
const ActionDashboard = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/action-dashboard")));
const Transactions = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/transactions")));
const DeletedTransactions = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/transactions/DeletedTransactions")));
const AuditPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/audit")));
const VendorPayment = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/VendorPayments")));
const Reimbursement = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reimbursement")));
const BonusMembers = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/bonus/members")));
const BonusMemberDetail = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/bonus/detail")));
const BonusListing = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/bonus/listing")));
const Inventory = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/inventory")));
const Category = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/category")));
const OfficeLocations = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/office-locations")));
const Vendors = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/Vendor")));
const VendorBills = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/vendorBills")));
const WorkOrders = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/workorders")));
const Brands = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/brands")));
// Removed unused Edit component import
const Ledger = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/ledger")));
const VendorCategory = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/vendoCategory")));
const TransactionCategory = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/transactionCategory")));
const InternalInvoicesIndex = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/internalInvoices")));
const Clients = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/client")));
const NewClients = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/client/NewClients")));
const Currencies = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/currencies")));
const Country = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/country")));
const OrganizationModule = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/organization")));
const Department = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/department")));
const BusinessVerticalsPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/businessVerticals")));
// Adding import for Financial Years component
const FinancialYearsList = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/financial-years")));
const ServicesPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/services")));
const EmailTemplates = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/email-templates")));

// Import Credit Notes components
const CreditNotes = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/creditNotes")));
const UsersPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/users")));
const PayRequest = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/pay-request')));
const VendorRequests = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/vendor-requests')));
// import { element } from "prop-types"; // unused
const ImportFormat = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/import-formats")));
const Bills = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/bills')));
const Discussions = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/discussions')));
const BillCopies = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/bill-copies')));
const ClientNoteIndexPage = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/client-notes/index')));
const ContractsPage = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/contracts')));
const ContractDetail = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/contracts/detail')));
const ContractForm = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/contracts/ContractForm')));
const PublicContractView = Loadable(lazy(() => import('./project-portal/pages/PublicContractView')));
const Invoices2 = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/invoices2")));
const FollowUps = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/follow-ups")));
const PurchaseOrders = Loadable(lazy(() => import('./project-portal/pages/DashboardMenus/purchase-orders/index')));
const Quotations = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/quotations")));
const ScheduleWorkOrder = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/workorders/scheduleWorkOrder")));
const Taxscheme = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/taxcode")));
const TaxCodesIndex = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/Tax-Codes")));
const SettingsPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/settings")));
const TdsPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/tds")));
const TaxReturnsPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/tax-returns")));
const TaxReturnsDetail = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/tax-returns/detail")));
const TaxReturnsInvoices = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/tax-returns/invoices")));
const Gstr2bPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/gstr2b")));
const AccountingTasksPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/accounting-tasks")));
const MonthlySalesReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports")));
const FinancialSummaryReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/FinancialSummaryReport")));
const MonthlySummaryReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/MonthlySummaryReport")));
const LineItemReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/LineItemReport")));
const InvoiceBonusReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/InvoiceBonusReport")));
const AssignBonusLineItems = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/AssignBonusLineItems")));
const PartnerShareReport = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/PartnerShareReport")));
const PartnerShareList = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/reports/PartnerShareReport/List")));
const DashboardPage = Loadable(lazy(() => import("./project-portal/pages/DashboardMenus/dashboard")));
const PublicInvoiceView = Loadable(lazy(() => import("./project-portal/pages/PublicInvoiceView")));
const PublicCreditNoteView = Loadable(lazy(() => import("./project-portal/pages/PublicCreditNoteView")));
const PublicBillView = Loadable(lazy(() => import("./project-portal/pages/PublicBillView")));
const PublicPayRequestView = Loadable(lazy(() => import("./project-portal/pages/PublicPayRequestView")));
const PublicLedgerView = Loadable(lazy(() => import("./project-portal/pages/PublicLedgerView")));
const PublicBonusLedgerView = Loadable(lazy(() => import("./project-portal/pages/PublicBonusLedgerView")));
const PublicKycForm = Loadable(lazy(() => import("./project-portal/pages/PublicKycForm")));


// Lazy loaded components
const AuthErrorPage = lazy(() => import("./components/auth/auth-error"));
const OrganizationDetail = lazy(() =>
  import("./project-portal/pages/DashboardMenus/organization/detail")
);

// Not found pages
const NotFound = Loadable(
  lazy(() =>
    import("./containers/not-found").then((module) => ({
      default: module.NotFound,
    }))
  )
);

// Auth pages
const Login = Loadable(
  lazy(() =>
    import("./pages/Login").then((module) => ({ default: module.Login }))
  )
);

const AuthCallback = Loadable(
  lazy(() => import("./components/auth/auth-callback"))
);

const LoadableOrganizationDetail = Loadable(OrganizationDetail);

const routes = [
  {
    path: "",
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    path: "auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "public/invoice/:uid",
    element: <PublicInvoiceView />,
  },
  {
    path: "public/contract/:uid",
    element: <PublicContractView />,
  },
  {
    path: "public/credit-note/:uid",
    element: <PublicCreditNoteView />,
  },
  {
    path: "public/bill/:uid",
    element: <PublicBillView />,
  },
  {
    path: "public/pay-request/:uid",
    element: <PublicPayRequestView />,
  },
  {
    path: "public/ledger/:uid",
    element: <PublicLedgerView />,
  },
  {
    path: "public/bonus-ledger/:uid",
    element: <PublicBonusLedgerView />,
  },
  {
    path: "public/kyc/:uid",
    element: <PublicKycForm />,
  },
  {
    path: "auth-error",
    element: <AuthErrorPage />,
  },
  {
    path: "forgot-password",
    element: (
      <GuestGuard>
        <ForgotPassword />
      </GuestGuard>
    ),
  },
  {
    path: "dashboard",
    element: (
      <AuthGuard>
        <ErrorBoundary fullPage>
          <DashboardLayout />
        </ErrorBoundary>
      </AuthGuard>
    ),
    // children: [
    //   {
    //     path: "",
    //     element: <Navigate to="/dashboard/employees" replace />,
    //   },
    //   {
    //     path: "employees",
    //     element: <Employees />,
    //   },
    //   {
    //     path: "business-heads",
    //     element: <BusinessHeads />,
    //   },
    //   {
    //     path: "subscriptions",
    //     element: <Subscriptions />,
    //   },
    //   {
    //     path: "taxaccounts",
    //     element: <TaxAccounts />,
    //   },
    //   {
    //     path: "paymentprofile",
    //     element: <Paymentprofiles />,
    //   },
    //   {
    //     path: "paymentchannels",
    //     element: <PaymentChannels />,
    //   },
    //   {
    //     path: "transactions",
    //     element: <Transactions />,
    //   },
    //   {
    //     path: "transaction-category",
    //     element: <TransactionCategory />,
    //   },
    //   {
    //     path: "business-invoices",
    //     element: <Invoices />,
    //   },
    //   {
    //     path: "business-invoices2",
    //     element: <Invoices2 />,
    //   },
    //   {
    //     path: "/dashboard/business-invoices2/:id/add",
    //     element: <Add />,
    //   },
    //   {
    //     path: "reimbursement",
    //     element: <Reimbursement />,
    //   },
    //   {
    //     path: "vendors",
    //     element: <Vendors />,
    //   },
    //   {
    //     path: "vendorpayment",
    //     element: <VendorPayment />,
    //   },
    //   {
    //     path: "vendor-bills",
    //     element: <VendorBills />,
    //   },
    //   {
    //     path: "inventory",
    //     element: <Inventory />,
    //   },
    //   {
    //     path: "category",
    //     element: <Category />,
    //   },
    //   {
    //     path: "work-orders",
    //     element: <WorkOrders />,
    //   },
    //   {
    //     path: "brands",
    //     element: <Brands />,
    //   },
    //   {
    //     path: "ledger",
    //     element: <Ledger />,
    //   },
    //   {
    //     path: "vendor-category",
    //     element: <VendorCategory />,
    //   },
    //   {
    //     path: "taxcode",
    //     element: <Taxcode />,
    //   },
    //   {
    //     path: "internal-invoice",
    //     element: <InternalInvoicesIndex />,
    //   },
    //   {
    //     path: "clients",
    //     element: <Clients />,
    //   },
    //   {
    //     path: "currencies",
    //     element: <Currencies />,
    //   },
    //   {
    //     path: "country",
    //     element: <Country />,
    //   },
    //   {
    //     path: "organization",
    //     element: <OrganizationModule />,
    //   },
    //   {
    //     path: "organization/:id",
    //     element: <LoadableOrganizationDetail />,
    //   },
    //   {
    //     path: "department",
    //     element: <Department />,
    //   },
    // ],
    children: [
      { path: "", element: <Navigate to="/dashboard/action" replace /> },
      { path: "action", element: <ActionDashboard /> },
      { path: "main", element: <DashboardPage /> },

      // ✅ Top-level pages
      { path: "employees", element: <Employees /> },
      { path: "users", element: <UsersPage /> },
      { path: "business-heads", element: <BusinessHeads /> },
      { path: "subscriptions", element: <Subscriptions /> },
      { path: "transactions", element: <Transactions /> },
      { path: "transactions/deleted", element: <DeletedTransactions /> },
      { path: "audit", element: <AuditPage /> },
      { path: "reimbursement", element: <Reimbursement /> },
      { path: "bonus/members", element: <BonusMembers /> },
      { path: "bonus/members/:id", element: <BonusMemberDetail /> },
      { path: "bonus/listing", element: <BonusListing /> },
      { path: "vendors", element: <Vendors /> },
      { path: "vendorpayment", element: <VendorPayment /> },
      { path: "vendor-bills", element: <VendorBills /> },
      { path: "inventory", element: <Inventory /> },

      {
        path: "work-orders",
        element: <WorkOrders />,
        children: [
          { path: "scheduled", element: <ScheduleWorkOrder /> }
        ]
      },
      { path: "pay-request", element: <PayRequest /> },
      { path: "vendor-requests", element: <VendorRequests /> },
      { path: "bills", element: <Bills /> },
      { path: "discussions", element: <Discussions /> },
      { path: "bill-copies", element: <BillCopies /> },
      { path: "ledger", element: <Ledger /> },
      { path: "internal-invoice", element: <InternalInvoicesIndex /> },
      { path: "clients", element: <Clients /> },
      { path: "clients/new", element: <NewClients /> },
      { path: "payment-profiles/:id", element: <PaymentProfileDetailPage /> },
      { path: "business-invoices", element: <Invoices2 /> },
      { path: "follow-ups", element: <FollowUps /> },
      // { path: "/dashboard/business-invoices2/:id/add", element: <Add /> },
      { path: "department", element: <Department /> },
      { path: "client-notes", element: <ClientNoteIndexPage /> },
      { path: "contracts", element: <ContractsPage /> },
      { path: "contracts/new", element: <ContractForm /> },
      { path: "contracts/:id/edit", element: <ContractForm /> },
      { path: "contracts/:id", element: <ContractDetail /> },
      { path: "purchase-orders", element: <PurchaseOrders /> },
      { path: "quotations", element: <Quotations /> },
      { path: "accounting-tasks", element: <AccountingTasksPage /> },
      { path: "reports/financial-summary", element: <FinancialSummaryReport /> },
      { path: "reports/monthly-summary", element: <MonthlySummaryReport /> },
      { path: "reports/monthly-sales", element: <MonthlySalesReport /> },
      { path: "reports/line-items", element: <LineItemReport /> },
      { path: "reports/invoice-bonuses", element: <InvoiceBonusReport /> },
      { path: "reports/assign-bonus", element: <AssignBonusLineItems /> },
      { path: "reports/partner-share", element: <PartnerShareList /> },
      { path: "reports/partner-share/create", element: <PartnerShareReport /> },
      { path: "reports/partner-share/:id", element: <PartnerShareReport /> },

      // Credit Notes routes
      { path: "credit-notes", element: <CreditNotes /> },

      // Tax routes
      { path: "tax/tds", element: <TdsPage /> },

      // Tax Returns routes
      { path: "tax-returns", element: <TaxReturnsPage /> },
      { path: "tax-returns/invoices", element: <TaxReturnsInvoices /> },
      { path: "tax-returns/:id", element: <TaxReturnsDetail /> },
      { path: "gstr2b", element: <Gstr2bPage /> },
      // { path: "credit-notes/create", element: <CreateCreditNote /> },
      // { path: "credit-notes/edit/:id", element: <EditCreditNote /> },

      {
        path: "masterdata",
        children: [
          {
            path: "",
            element: (
              <Navigate to="/dashboard/masterdata/organization" replace />
            ),
          },
          { path: "organization", element: <OrganizationModule /> },
          { path: "organization/:id", element: <LoadableOrganizationDetail /> },
          { path: "taxaccounts", element: <TaxAccounts /> },
          { path: "paymentchannels", element: <PaymentChannels /> },
          { path: "taxscheme", element: <Taxscheme /> },
          { path: "taxcode", element: <TaxCodesIndex /> },
          { path: "paymentprofile", element: <Paymentprofiles /> },
          { path: "country", element: <Country /> },
          { path: "currencies", element: <Currencies /> },
          { path: "settings", element: <SettingsPage /> },
          { path: "transaction-category", element: <TransactionCategory /> },
          { path: "vendor-category", element: <VendorCategory /> },
          { path: "category", element: <Category /> },
          { path: "office-locations", element: <OfficeLocations /> },
          { path: "brands", element: <Brands /> },
          { path: "import-formats", element: <ImportFormat /> },
          { path: "business-verticals", element: <BusinessVerticalsPage /> },
          // Adding Financial Years route
          { path: "financial-years", element: <FinancialYearsList /> },
          { path: "services", element: <ServicesPage /> },
          { path: "email-templates", element: <EmailTemplates /> },
        ],
      },

      {
        path: "organization",
        element: <Navigate to="/dashboard/masterdata/organization" replace />,
      },
      {
        path: "organization/:id",
        element: (
          <Navigate to="/dashboard/masterdata/organization/:id" replace />
        ),
      },
      {
        path: "taxaccounts",
        element: <Navigate to="/dashboard/masterdata/taxaccounts" replace />,
      },
      {
        path: "paymentchannels",
        element: (
          <Navigate to="/dashboard/masterdata/paymentchannels" replace />
        ),
      },
      {
        path: "taxscheme",
        element: <Navigate to="/dashboard/masterdata/taxscheme" replace />,
      },
      {
        path: "taxcode",
        element: <Navigate to="/dashboard/masterdata/taxcode" replace />,
      },
      {
        path: "paymentprofile",
        element: <Navigate to="/dashboard/masterdata/paymentprofile" replace />,
      },
      {
        path: "country",
        element: <Navigate to="/dashboard/masterdata/country" replace />,
      },
      {
        path: "currencies",
        element: <Navigate to="/dashboard/masterdata/currencies" replace />,
      },
      {
        path: "transaction-category",
        element: (
          <Navigate to="/dashboard/masterdata/transaction-category" replace />
        ),
      },
      {
        path: "vendor-category",
        element: (
          <Navigate to="/dashboard/masterdata/vendor-category" replace />
        ),
      },
      {
        path: "category",
        element: <Navigate to="/dashboard/masterdata/category" replace />,
      },
      {
        path: "brands",
        element: <Navigate to="/dashboard/masterdata/brands" replace />,
      },
      {
        path: "import-formats",
        element: <Navigate to="/dashboard/masterdata/import-formats" replace />,
      },
      {
        path: "business-verticals",
        element: <Navigate to="/dashboard/masterdata/business-verticals" replace />, // Redirect to masterdata version
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
